import {
  GET_REPORT,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAIL,
  REPORT_LOADING,
  REPORT_RESET
} from "./actionType";

export const resetReportState = (actionType) => ({
  type: REPORT_RESET,
  payload: { actionType },
});

export const getReportSuccess = (actionType, data) => ({
  type: GET_REPORT_SUCCESS,
  payload: { actionType, data },
});

export const getReportFail = (actionType, error) => ({
  type: GET_REPORT_FAIL,
  payload: { actionType, error },
});

export const getReport = (report, path) => ({
  type: GET_REPORT,
  payload: {
    report,
    path
  },
});

export const getReportLoading = () => ({
  type: REPORT_LOADING
});